"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CommunityService = void 0;
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _Api = _interopRequireDefault(require("../Api"));
var _excluded = ["token"],
  _excluded2 = ["token", "id"],
  _excluded3 = ["token", "id"],
  _excluded4 = ["token", "id"],
  _excluded5 = ["token", "id"],
  _excluded6 = ["token"],
  _excluded7 = ["token"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var CommunityService = exports.CommunityService = /*#__PURE__*/(0, _createClass2["default"])(function CommunityService() {
  (0, _classCallCheck2["default"])(this, CommunityService);
});
(0, _defineProperty2["default"])(CommunityService, "listHandouts", function (_ref) {
  var token = _ref.token,
    params = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  return _Api["default"].withAuth(token).get('/handout', {
    params: params
  });
});
(0, _defineProperty2["default"])(CommunityService, "getHandoutById", function (_ref2) {
  var token = _ref2.token,
    id = _ref2.id,
    params = (0, _objectWithoutProperties2["default"])(_ref2, _excluded2);
  return _Api["default"].withAuth(token).get("/handout/".concat(id), {
    params: params
  });
});
(0, _defineProperty2["default"])(CommunityService, "approveHandout", function (_ref3) {
  var token = _ref3.token,
    id = _ref3.id,
    params = (0, _objectWithoutProperties2["default"])(_ref3, _excluded3);
  return _Api["default"].withAuth(token).post("/handout/".concat(id, "/approve"), _objectSpread({}, params));
});
(0, _defineProperty2["default"])(CommunityService, "denyHandout", function (_ref4) {
  var token = _ref4.token,
    id = _ref4.id,
    params = (0, _objectWithoutProperties2["default"])(_ref4, _excluded4);
  return _Api["default"].withAuth(token).post("/handout/".concat(id, "/deny"), _objectSpread({}, params));
});
(0, _defineProperty2["default"])(CommunityService, "cancelHandout", function (_ref5) {
  var token = _ref5.token,
    id = _ref5.id,
    params = (0, _objectWithoutProperties2["default"])(_ref5, _excluded5);
  return _Api["default"].withAuth(token).post("/handout/".concat(id, "/cancel"), _objectSpread({}, params));
});
(0, _defineProperty2["default"])(CommunityService, "createNotice", function (_ref6) {
  var token = _ref6.token,
    params = (0, _objectWithoutProperties2["default"])(_ref6, _excluded6);
  return _Api["default"].withAuth(token).post('/handout/notice', _objectSpread({}, params));
});
(0, _defineProperty2["default"])(CommunityService, "createBulletin", function (_ref7) {
  var token = _ref7.token,
    params = (0, _objectWithoutProperties2["default"])(_ref7, _excluded7);
  return _Api["default"].withAuth(token).post('/handout/bulletin', _objectSpread({}, params));
});